import { Box, Text, Tooltip } from '@wix/design-system';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
export const getSectionDividerItem = group => {
  return {
    key: group.groupId,
    render: () => /*#__PURE__*/React.createElement(Box, {
      backgroundColor: group.backgroundColor,
      gap: "1px",
      key: group.groupId,
      padding: "9px 18px",
      verticalAlign: "middle",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin",
      secondary: true
    }, group.groupId), /*#__PURE__*/React.createElement(Box, {
      color: "#42454C",
      marginTop: "4px"
    }, group.tooltipContent && /*#__PURE__*/React.createElement(Tooltip, {
      content: group.tooltipContent,
      size: "small"
    }, /*#__PURE__*/React.createElement(InfoCircleSmall, null))))
  };
};
//# sourceMappingURL=get-section-divider-item.js.map